import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { getDoc, doc } from "firebase/firestore";
import { PLATFORM_ICONS, fallbackContacts } from "./contactsConfig";

export default function Contact() {
  const [contacts, setContacts] = useState(null); // null = loading

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "settings", "site"));
        if (!active) return;
        if (snap.exists() && Array.isArray(snap.data().contacts) && snap.data().contacts.length) {
          setContacts(snap.data().contacts);
        } else {
          setContacts(fallbackContacts);
        }
      } catch (e) {
        console.error("Could not load contacts, using fallback.", e);
        if (active) setContacts(fallbackContacts);
      }
    })();
    return () => { active = false; };
  }, []);

  const buildHref = (c) => {
    if (c.platform === "Email") return `mailto:${c.value}`;
    if (/^https?:\/\//.test(c.value)) return c.value;
    return `https://${c.value}`;
  };

  return (
    <div className="contact-page">
      <div className="contact-head">
        <span className="hero__badge">✦ Let's work together</span>
        <h1 className="contact-title">Have a custom idea?</h1>
        <p className="contact-sub">I'd love to hear about your project and bring it to life in 3D.</p>
      </div>

      <div className="contact-divider">✦</div>

      <div className="contact-grid">
        {(contacts || []).map((c, i) => (
          <div className="contact-card" key={i}>
            <div className="contact-card__icon">
              {PLATFORM_ICONS[c.platform] || PLATFORM_ICONS.Link}
            </div>
            <h3 className="contact-card__label">{c.label || c.platform}</h3>
            <p className="contact-card__desc">{c.desc}</p>
            <a href={buildHref(c)} target="_blank" rel="noopener noreferrer" className="contact-card__link">{c.value}</a>
          </div>
        ))}
      </div>

      <div className="quick-response">
        <div className="quick-response__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
        </div>
        <div className="quick-response__text">
          <strong>Quick Response</strong>
          <p>I usually reply within 24–48 hours.<br/>I read every message and look forward to working with you.</p>
        </div>
      </div>
    </div>
  );
}
